import { PROJECT_ID, S3_UPLOAD_URL } from './supabase';

export async function uploadImage(file: File): Promise<string> {
  const res = await fetch(S3_UPLOAD_URL, {
    method: 'POST',
    headers: {
      'x-project-id': PROJECT_ID,
      'x-file-name': encodeURIComponent(file.name),
      'Content-Type': file.type,
    },
    body: file,
  });

  if (!res.ok) {
    throw new Error(`upload failed with status ${res.status}`);
  }

  let result: { success?: boolean; url?: string } | null = null;
  try {
    result = await res.json();
  } catch {
    throw new Error('upload failed: invalid response');
  }

  if (!result?.success || !result?.url) {
    throw new Error('upload failed: url not found in response');
  }

  return result.url;
}